import PopupManager from "../../Common/Popups/PopupManager";
import { formatDateTime } from "../../Utilities/Generic/Strings";

let popupId: undefined | string | number;

export function localTimeMismatchWarning(offset: number, localTime?: string, serverTime?: string): void {
    // If offset is larger than 5 minutes (as milliseconds) then we warn the user.
    if(Math.abs(offset) >= 5 * 60 * 1000) {
        if(popupId) {
            PopupManager.remove(popupId);
        }

        popupId = PopupManager.create({
            message: (
                <a
                    href="#"
                    onClick={(e: React.MouseEvent): void => {
                        e.preventDefault();
                        window.location.reload();
                    }}
                >
                    The date on your computer{localTime ? ` (${formatDateTime(localTime)})` : ""} has a large difference to
                    the server&apos;s time{serverTime ? ` (${formatDateTime(serverTime)})` : ""}.
                    Please fix the time on your computer and refresh all Shopfront pages otherwise Shopfront
                    may not work correctly.
                </a>
            ),
            icon   : "exclamation",
            classes: [ "popup-warning" ],
            timeout: 0,
        });
    }
}
